export default function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}


//////////////////
// WEBPACK FOOTER
// ./~/@popperjs/core/lib/utils/getAltAxis.js
// module id = 734
// module chunks = 93